//Humberger menu
export function navbar() {
	// Get all "navbar-burger" elements
	const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll(".aida_header_burger"), 0);
	// Check if there are any navbar burgers
	if ($navbarBurgers.length > 0) {
		$navbarBurgers.forEach(el => {
			el.addEventListener("click", () => {
				const target = el.dataset.target;
				const $target = document.getElementById(target);
				el.classList.toggle("_active");
				$target.classList.toggle("_active");
			});
		});
	}
}

export function footerNav() {
	const $footerNavLabel = Array.prototype.slice.call(document.getElementsByClassName("aida_footer")[0].querySelectorAll("dt"), 0);
	$footerNavLabel.forEach(el => {
		el.addEventListener("touchend", function() {
			this.classList.toggle("_show");
		})
	})
}

//Lazy loading
export function lazyLoad() {
	const lazyLoad = Array.prototype.slice.call(document.body.querySelectorAll(".js-lazy-load"), 0)
	const options = {
		rootMargin: "0px",
		threshold: [0]
	};
	const lazyLoader = (el) => {
		el.forEach(t => {
			if (t.intersectionRatio > 0) {
				// console.log(t)
				const $t = t.target;
				const data = $t.dataset.src;
				$t.setAttribute("src", data);
				// console.log($t,data);
				$t.classList.add("lazy-loaded")
				isObserver.unobserve($t);
			}
		});
	};
	const isObserver = new IntersectionObserver(lazyLoader, options)
	lazyLoad.forEach(el => {
		isObserver.observe(el);
	});
}

//frame in animation
export function fiAnime() {
	const fiAnime= Array.prototype.slice.call(document.body.querySelectorAll("._anime_in"), 0)
	const options = {
		rootMargin: "0px",
		threshold: [0]
	};
	const addfiAnime = (el) => {
		el.forEach(t => {
			if (t.intersectionRatio > 0) {
				const $t = t.target;
				// console.log("t:",$t)
				$t.classList.add("_anime_show");
				isObserverAnime.unobserve($t);
			}
		});
	}
	const isObserverAnime = new IntersectionObserver(addfiAnime, options)
	fiAnime.forEach(el => {
		isObserverAnime.observe(el)
	});
}

//products
// export function productFeature() {
// 	const featureElements = Array.prototype.slice.call(document.body.querySelectorAll(".product_feature_key", 0))
// 	const allKeys = [];
// 	featureElements.forEach(e => {
// 		const key = e.getAttribute("data-category");
// 		allKeys.push(key);
// 	})
// 	const uniqueKeys = allKeys.filter(onlyUnique);

// 	const $icons = document.getElementById("prd_icons");
// 	uniqueKeys.forEach(k => {
// 		$icons.innerHTML += `<div class="_${k} feature_key">${featureList[k]}</div>`;
// 	})

// 	function onlyUnique(value, index, self) {
// 		return self.indexOf(value) === index;
// 	}
// }

//Modal
export function modal() {
	//opener
	const opener = Array.prototype.slice.call(document.body.querySelectorAll(".modal_switch"));
	opener.forEach(el => {
		el.addEventListener("click", function() {
			const id = this.getAttribute("data-id");
			const targetModal = document.getElementById(`${id}`);
			targetModal.classList.add("is-active");
		});
	})
	//closer
	const setCloser = (el)=> {
		//Hide parent element
		el.addEventListener("click", function() {
			const wrapper = this.parentElement;
			wrapper.classList.remove("is-active");
			const iframes = getIframeMovie(wrapper);
			iframes.forEach(el => {
//Add param "enablejsapi=1" to iframe url
//<iframe src="https://www.youtube.com/embed/ID?enablejsapi=1" width="720" height="405" allowfullscreen></iframe>
				el.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
			});
		});
	}
	//Get iframe videos in the modal
	const getIframeMovie = (el) => {
		const iframeMovie = Array.prototype.slice.call(el.querySelectorAll("iframe"), 0);
		return iframeMovie;
	}
	const closeButton = Array.prototype.slice.call(document.body.querySelectorAll(".modal-close"), 0);
	closeButton.forEach(el => {
		setCloser(el);
	});
	const modalBg = Array.prototype.slice.call(document.body.querySelectorAll(".modal-background"), 0);
	modalBg.forEach(el => {
		setCloser(el);
	});
}

//Swiper Slide Control on a Modal
export function modalSwiperCtrl(swiperObj) {
	if (swiperObj === null) return;
	const thumbs = Array.prototype.slice.call(document.body.querySelectorAll(".modal_slide_thumb"));
	thumbs.forEach(el => {
		el.addEventListener("click", function() {
			// thumbs.forEach(thumb => {
			// 	thumb.classList.remove("_active");
			// })
			// this.classList.add("_active");
			const index = this.getAttribute("data-index");
			swiperObj.slideTo(index);
		});
	})
}

//molded sample
export function moldedSize() {
	const small = document.getElementById("sample_small");
	const medium = document.getElementById("sample_medium");
	const large = document.getElementById("sample_large");
	const cards = Array.prototype.slice.call(document.body.querySelectorAll(".aida_sample_index_card"), 0);
	if (small!==null) {
		small.addEventListener("click", function() {
			removeSizeClasses(cards);
			cards.forEach(el => {
				el.classList.add("is-one-fifth-desktop","is-one-quarter-tablet","is-one-quarter-mobile","_small")
			});
			removeButtonClass();
			addButtonClass(this);
		})
	}
	if (medium!==null) {
		medium.addEventListener("click", function() {
			removeSizeClasses(cards);
			cards.forEach(el => {
				el.classList.add("is-one-third-desktop","is-one-third-tablet","is-half-mobile","_medium")
			});
			removeButtonClass();
			addButtonClass(this);
		})
	}
	if (large!==null) {
		large.addEventListener("click", function() {
			removeSizeClasses(cards);
			cards.forEach(el => {
				el.classList.add("is-half-desktop","is-half-tablet","is-full-mobile","_large")
			});
			removeButtonClass();
			addButtonClass(this);
		})
	}
	function removeSizeClasses(arr) {
		arr.forEach(el => {
			el.classList.remove(
				"is-one-fifth-desktop","is-one-quarter-tablet","is-one-quarter-mobile",
				"is-one-third-desktop","is-one-third-tablet","is-half-mobile",
				"is-half-desktop","is-half-tablet","is-full-mobile",
				"_small","_medium","_large"
			);
		});
	}
	function removeButtonClass() {
		const buttons = Array.prototype.slice.call(document.body.querySelectorAll(".aida_sample_size_chooser"),0);
		buttons.forEach(btn => {
			btn.classList.remove("_current");
		})
	}
	function addButtonClass(btn) {
		btn.classList.add("_current");
	}
}

export function classCtrl() {
	//for scrolling table
	const scrollHint = document.querySelectorAll(".aida_scroll_hint");
	scrollHint.forEach(el => {
		el.outerHTML = `<div class="js-scroll-hint">${el.outerHTML}</div>`;
	})
}

export function currentUrl() {
	const url = window.location.href;
	const nav = Array.prototype.slice.call(document.getElementsByClassName("aida_header_globalnav_link"),0);
	nav.forEach(el => {
		const href = el.getAttribute("href")
		const findUrl = url.indexOf(href)
		if (findUrl>=0) {
			el.classList.add("_current");
		}
	})
}

export function coverwrap() {//フォーム送信するとカバーを表示
	const form = document.getElementById("show_coverwrap");
	const cover = document.getElementById("coverwrap");
	if (!!form && !!cover) {
		form.addEventListener("submit", function() {
			cover.classList.add("_show");
		})
	}
}

export function acms() {
	if (typeof ACMS === "function") {
		ACMS.Ready(function () {
			ACMS.Config.LiteEditorConf.btnOptions = [
				{
					label: 'リンク',
					tag: 'a',
					sampleText: 'リンク'
				},
				{
					label: '強調',
					tag: 'strong',
					className: '',
					sampleText: '強調'
				},
				{
					label: '右寄せ',
					tag: 'span',
					className: 'has-text-right',
					sampleText: '右寄せ'
				}
			];
			ACMS.Config.aTableOption = [
				{
					label: "スクロールヒント",
					value: "aida_scroll_hint"
				},
				{
					label: "罫線なし",
					value: "aida_no_border"
				}
			];
			// ACMS.Config.flatDatePickerConfig = {
			// 	dateFormat: 'Y.m.d'
			// };
		});
	}
}